/**
 * PDP Video Autoplay Enhancements
 * - Click-to-toggle play/pause on autoplay videos (no native controls)
 * - Re-initializes after AJAX section rendering
 */
(function () {
  'use strict';

  /**
   * Attach click-to-toggle handler on a video-media element
   */
  function initVideoToggle(videoMedia) {
    if (!videoMedia.hasAttribute('autoplay') || videoMedia.getAttribute('group') !== 'product') return;
    if (videoMedia.dataset.toggleInit) return;
    videoMedia.dataset.toggleInit = 'true';

    videoMedia.style.cursor = 'pointer';

    videoMedia.addEventListener('click', function (e) {
      if (e.target.tagName === 'VIDEO' && e.target.controls) return;

      e.preventDefault();
      e.stopPropagation();

      if (videoMedia.playing) {
        videoMedia.pause();
      } else {
        videoMedia.play();
      }
    });
  }

  function initAllVideos(root) {
    var elements = (root || document).querySelectorAll('video-media[autoplay][group="product"]');
    elements.forEach(initVideoToggle);
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllVideos(); });
  } else {
    initAllVideos();
  }

  // Re-init after Shopify AJAX section rendering
  document.addEventListener('shopify:section:load', function (e) {
    initAllVideos(e.target);
  });

  // Catch any dynamically inserted video-media elements
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName && node.tagName.toLowerCase() === 'video-media') {
          initVideoToggle(node);
        }
        if (node.querySelectorAll) {
          initAllVideos(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
